export const PROFIL_GET = 'PROFIL_GET';
export const PROFIL_UPDATE = 'PROFIL_UPDATE';